import {encryption} from "@/utils/util";
import {Login,refreshToken,getUserInfo,logout} from "@/network/login";
import store from "@/store/index";
import qs from 'qs';

export default {
  Login({commit,dispatch}, userInfo) {
    const user = encryption({
      data: userInfo,
      key: 'pigxpigxpigxpigx',
      param: ['password']
    })
    return new Promise((resolve, reject) => {
      Login(user.username, user.password).then(response => {
        const data = response.data
        commit('setToken', {'access_token':data['access_token'],
                            'refresh_token':data['refresh_token'],
                              'expires_in':data['expires_in']
        },)
        dispatch('GetUserInfo')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  RefreshToken({commit, state}) {
    return new Promise((resolve, reject) => {
      refreshToken(state.refresh_token).then(response => {
        const data = response.data
        commit('setToken', {'access_token':data['access_token'],
          'refresh_token':data['refresh_token'],
          'expires_in':data['expires_in'],},)
        resolve(response)
      }).catch(error => {
        commit('cleanLocal')
        reject(error)
      })
    })
  },
  GetUserInfo({commit}) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        const data = res.data.data
        commit('setUserInfo',JSON.stringify(data['sysUser']))
        // commit('setUserMenu',data['permissions'])
        commit('setCertification',JSON.stringify(data['sysUser'].certification))
        resolve()
      }).catch(err => {
        commit('cleanLocal')
        // commit('setUserMenu',['3'])
        reject()
      })
    })
  },
  GetCertification({commit}) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        // console.log(res)
        const data = res.data.data.sysUser.certification
        commit('setCertification',{'certification':data['certification']})
        resolve()
      }).catch(err => {
        commit('cleanLocal')
        reject()
      })
    })
  },
  LoginOut({commit}){
    return new Promise((resolve,reject)=>{
      logout().then(res=>{
        // commit('setUserMenu',['3'])
        commit('cleanLocal')
        // commit('setPendingNum','')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // GetPending({commit}){
  //   return new Promise((resolve, reject) => {
  //     getPending().then(res=>{
  //       // commit('setPendingNum',res.data.data)
  //       commit('setPendingNum',res.data.data.countPending)
  //       commit('setSubmitNum',res.data.data.countSubmitt)
  //     })
  //   })
  // }
}
